module.exports = __webpack_public_path__ + "static/media/sharing.2c4933bf.svg";